import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import '../../styles/CommonStyles.css';

function TermsConditionsPage() {
  return (
    <div className="page-container">
      <Header />
      
      <div className="page-header">
        <h1>TERMS AND CONDITIONS</h1>
        <p>Please read these terms carefully before using our services</p>
      </div>
      
      <section className="content-section">
        <div className="legal-container" style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div className="last-updated" style={{ 
            fontSize: '0.9rem', 
            fontStyle: 'italic', 
            marginBottom: '2rem',
            color: '#666'
          }}>
            Last Updated: June 30, 2025
          </div>

          <div className="terms-section">
            <h2>1. AGREEMENT TO TERMS</h2>
            <p>
              These Terms and Conditions ("Terms") govern your access to and use of the Bangalore Valuers' Association 
              ("BVA," "we," "our," or "us") website and services. By accessing or using our services, you agree to 
              be bound by these Terms. If you disagree with any part of these Terms, you may not access our services.
            </p>
          </div>

          <div className="terms-section">
            <h2>2. DEFINITIONS</h2>
            <p>
              In these Terms, the following definitions apply:
            </p>
            <ul>
              <li><strong>"Services"</strong> refers to the BVA website, membership, events, programs, resources, and any other services offered by BVA.</li>
              <li><strong>"User"</strong> refers to any individual who accesses or uses the Services.</li>
              <li><strong>"Member"</strong> refers to any individual or organization that has paid for and been granted membership to BVA.</li>
              <li><strong>"Content"</strong> refers to any information, text, graphics, photos, or other materials uploaded, downloaded, or appearing on the Services.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>3. MEMBERSHIP</h2>
            <h3>3.1 Eligibility</h3>
            <p>
              Membership is available to individuals and organizations that meet the eligibility criteria established by BVA. 
              We reserve the right to reject membership applications or terminate memberships at our sole discretion.
            </p>

            <h3>3.2 Membership Types and Fees</h3>
            <p>
              BVA offers various membership types, each with its own benefits and fees. Membership fees are typically 
              charged on an annual basis, though other billing periods may be available for certain membership types. 
              Membership fees are non-refundable, except as required by law or as explicitly stated in these Terms.
            </p>

            <h3>3.3 Member Conduct</h3>
            <p>
              Members agree to:
            </p>
            <ul>
              <li>Provide accurate and complete information when registering and maintain the accuracy of such information;</li>
              <li>Comply with all applicable laws and regulations;</li>
              <li>Use BVA services in a manner consistent with professional standards;</li>
              <li>Keep membership credentials (such as usernames and passwords) confidential;</li>
              <li>Not engage in any activity that could harm BVA's reputation or interfere with the operation of our services.</li>
            </ul>

            <h3>3.4 Membership Renewal and Termination</h3>
            <p>
              Memberships are valid for the specified term and may be renewed upon payment of the applicable renewal fee. 
              BVA may terminate or suspend membership if a member violates these Terms or engages in conduct that BVA, 
              in its sole discretion, deems harmful to the organization or its members.
            </p>
          </div>

          <div className="terms-section">
            <h2>4. PROFESSIONAL LISTINGS</h2>
            <p>
              BVA provides a platform for members and non-members to list their professional services. By submitting a 
              professional listing, you represent and warrant that:
            </p>
            <ul>
              <li>All information provided is accurate, current, and complete;</li>
              <li>You have the necessary qualifications, licenses, and certifications to provide the listed services;</li>
              <li>You will update the listing information to maintain its accuracy;</li>
              <li>You have obtained all necessary permissions for any third-party content included in your listing.</li>
            </ul>
            <p>
              BVA reserves the right to review, reject, or remove any professional listing at its sole discretion.
            </p>
          </div>

          <div className="terms-section">
            <h2>5. EVENTS AND PROGRAMS</h2>
            <p>
              BVA organizes various events and programs for members and non-members. By registering for these events 
              and programs, you agree to:
            </p>
            <ul>
              <li>Pay the applicable registration fees;</li>
              <li>Provide accurate registration information;</li>
              <li>Comply with the specific terms and conditions of each event or program;</li>
              <li>Grant BVA permission to use photographs and recordings taken during the event for promotional purposes.</li>
            </ul>
            <p>
              Registration fees are non-refundable unless the event is canceled by BVA or as otherwise specified in 
              the event-specific terms.
            </p>
          </div>

          <div className="terms-section">
            <h2>6. INTELLECTUAL PROPERTY</h2>
            <h3>6.1 BVA Content</h3>
            <p>
              All Content provided by BVA, including but not limited to text, graphics, logos, images, audio clips, 
              digital downloads, and data compilations, is the property of BVA or its content suppliers and is protected 
              by intellectual property laws. You may not use, reproduce, distribute, modify, or create derivative works 
              of such Content without explicit permission from BVA.
            </p>

            <h3>6.2 User Content</h3>
            <p>
              By submitting Content to BVA (such as professional listings, forum posts, or comments), you grant BVA 
              a non-exclusive, worldwide, royalty-free, perpetual, irrevocable license to use, reproduce, modify, 
              adapt, publish, translate, distribute, and display such Content in connection with the Services.
            </p>
            <p>
              You represent and warrant that you own or have the necessary rights to the Content you submit and that 
              such Content does not violate the rights of any third party.
            </p>
          </div>

          <div className="terms-section">
            <h2>7. LIMITATION OF LIABILITY</h2>
            <p>
              To the maximum extent permitted by law, BVA shall not be liable for any indirect, incidental, special, 
              consequential, or punitive damages arising out of or in connection with your use of the Services, whether 
              based on warranty, contract, tort (including negligence), or any other legal theory, even if BVA has been 
              advised of the possibility of such damages.
            </p>
            <p>
              BVA's total liability for any claim arising out of or relating to these Terms or the Services shall not 
              exceed the amount you paid to BVA during the 12-month period preceding such claim.
            </p>
          </div>

          <div className="terms-section">
            <h2>8. INDEMNIFICATION</h2>
            <p>
              You agree to indemnify, defend, and hold harmless BVA and its officers, directors, employees, agents, 
              and representatives from and against any claims, liabilities, damages, losses, costs, expenses, or fees 
              (including reasonable attorneys' fees) arising from:
            </p>
            <ul>
              <li>Your violation of these Terms;</li>
              <li>Your use of the Services;</li>
              <li>Content you submit, post, or transmit through the Services;</li>
              <li>Your violation of any rights of another person or entity.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>9. GOVERNING LAW AND JURISDICTION</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of India, without regard to its 
              conflict of law provisions. Any dispute arising out of or relating to these Terms or the Services shall be 
              subject to the exclusive jurisdiction of the courts located in Bangalore, Karnataka, India.
            </p>
          </div>

          <div className="terms-section">
            <h2>10. CHANGES TO TERMS</h2>
            <p>
              BVA reserves the right to modify these Terms at any time. We will notify users of material changes by 
              posting the updated Terms on our website with a new "Last Updated" date. Your continued use of the Services 
              after any such changes constitutes your acceptance of the new Terms.
            </p>
          </div>

          <div className="terms-section">
            <h2>11. SEVERABILITY</h2>
            <p>
              If any provision of these Terms is held to be invalid or unenforceable, such provision shall be struck and 
              the remaining provisions shall be enforced to the fullest extent under law.
            </p>
          </div>

          <div className="terms-section">
            <h2>12. ENTIRE AGREEMENT</h2>
            <p>
              These Terms, along with the Privacy Policy and any other legal notices published by BVA, constitute the entire 
              agreement between you and BVA concerning the Services.
            </p>
          </div>

          <div className="terms-section">
            <h2>13. CONTACT INFORMATION</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <div style={{ margin: '1rem 0' }}>
              <p>
                <strong>Bangalore Valuers' Association</strong><br />
                Email:  info@bangalorevaluers.org<br />
                Address: 522C, 1st D Cross, 15th Main, 3rd Stage, 4th Block, Basaveshwaranagar, Bangalore - 560 079 Karnataka State, INDIA
                <br/>
                <strong>Admin:</strong> <a href="tel:+918088383543">+91 8088383543</a>
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default TermsConditionsPage;
